var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileuploadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 48,
    viewBox: "0 0 72 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.05 18.12C57.0423 13.0132 54.2928 8.41458 50.2712 5.10974C46.2496 1.8049 41.2053 -0.00117673 36 5.7521e-07C27.33 5.7521e-07 19.8 4.92 16.05 12.12C11.6407 12.5965 7.56302 14.6856 4.60047 17.986C1.63791 21.2863 -0.000515105 25.565 1.21478e-07 30C1.21478e-07 39.93 8.07 48 18 48H57C65.28 48 72 41.28 72 33C72 25.08 65.85 18.66 58.05 18.12ZM42 27V39H30V27H21L34.95 13.05C35.55 12.45 36.48 12.45 37.08 13.05L51 27H42Z",
    fill: "#C3C3C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileuploadIcon);
export default __webpack_public_path__ + "static/media/fileupload-icon.030aa06f82b49d038b341485f9afb158.svg";
export { ForwardRef as ReactComponent };